<template>
    <the-nav-dialog-layout ref="dialog" v-slot="{ type }" title="外观设置" :navs="navs">
        <component :is="type"></component>
    </the-nav-dialog-layout>
</template>
<script>
import LoginConfig from '@/components/desk-header/components/configs/login-config';
import DesktopConfig from '@/components/desk-header/components/configs/desktop-config';
import TheNavDialogLayout from '@/components/desk-header/components/the-nav-dialog-layout';

const defaultType = 'LoginConfig';
const navs = Object.freeze([
    ['LoginConfig', '登录页'],
    ['DesktopConfig', '桌面']
]);

export default {
    name: 'TheAppearanceSettingsDialog',

    components: { TheNavDialogLayout, LoginConfig, DesktopConfig },

    data() {
        return {
            navs
        };
    },

    methods: {
        open(type = defaultType) {
            this.$refs.dialog.open(type);
        }
    }
};
</script>

<style lang="scss" scoped>
.common-settings-wrapper {
    .page {
        height: 800px;
        box-shadow: 0px 2px 4px 0px rgba(230, 180, 180, 0.2);
        border-radius: 2px;
    }

    ::v-deep {
        .isc-dialog {
            padding: 0;

            &__body {
                padding: 0;
            }
        }
    }
}
</style>
